import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Footer from '../Footer'

import { setCMSMalls } from '../../../../modules/dashboard/actions/creators'

const mapStateToProps = reduxState => {
  const { dashboard } = reduxState

  const { cmsMalls } = dashboard

  return {
    cmsMalls,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCMSMalls,
    },
    dispatch,
  )

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(Footer)

export default ConnectedComponent
